import Header from '../Components/Header/Header';
import Nav from '../Components/Nav/Nav';
import React, { useEffect, useState } from 'react';
import PageHead from '../Components/PageHead/PageHead';
import axios from 'axios';
import { useRouter } from 'next/router';
import { api } from '../../store/static.js';
import store from '../../store';
import { getUserData } from '../../store/actions/user';
import { useDispatch, useSelector } from 'react-redux';
import { getPaymentInterfaceMerchants } from '../../store/actions/paymentInterface';
import { rolesDataFetched } from '../../store/actions/roles';

const Layout = (props) => {
  const [change, setchange] = useState(true);
  const userData = useSelector((state) => state.user.user);
  const [loading, setLoading] = useState(true);
  const [permissions, setPermissions] = useState(null);
  let router = useRouter();
  const dispatch = useDispatch();

  const tokenFunction = async () => {
    let token = localStorage.getItem('token');
    if (token) setLoading(false);
    else router.push('/login');
    dispatch(getUserData(token, null, router));
    // dispatch(getPaymentInterfaceMerchants());
  };
  useEffect(() => {
    tokenFunction();
  }, [change]);

  useEffect(() => {
    if (userData && userData.role_id) {
      let token = localStorage.getItem('token');
      const headers = {
        'Content-Type': 'application/json',
        authorization: token,
      };
      axios
        .get(process.env.BASE_URL + '/api/user/roles?page=1&pageSize=100', {
          headers: headers,
          // params: params,
        })
        .then((res) => {
          const filteredRole = res.data.data.roles.find((u) => u.id == userData.role_id);
          dispatch(rolesDataFetched(res.data.data.roles));
          setPermissions(filteredRole.permissions);
          dispatch({
            type: 'USER_DATA_ROLE',
            payload: { roleName: filteredRole.name, rolePermissions: filteredRole.permissions },
          });
        })
        .catch((err) => {});
    }
  }, [userData]);

  return loading || !permissions ? null : (
    <div className={`${props.deviceType}`}>
      {userData && <Header userData={userData} />}
      <div className='main-container' style={{ display: 'flex' }}>
        <Nav permissions={permissions} />
        {props.children}
      </div>
    </div>
  );
};

export default Layout;
